import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IServiceOrderSearchResult } from "../../declarations/ServiceOrderSearch";

const searchForServiceOrderHeaders = async (
    searchTerm: string,
): Promise<IServiceOrderSearchResult[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IServiceOrderSearchResult[]>(
        "/ServiceOrder/SearchForServiceOrderHeaders",
        { searchTerm },
    );
    return response.data;
};

export const useSearchForServiceOrderHeaders = (searchTerm: string) =>
    useQuery<IServiceOrderSearchResult[]>({
        enabled: searchTerm.length > 3,
        queryFn: () => searchForServiceOrderHeaders(searchTerm!),
        queryKey: ["SearchForServiceOrderHeaders", searchTerm],
        refetchOnWindowFocus: false,
        retry: false,
        select: (data) => data ?? [],
    });
